import React, { useEffect, useState,useRef  } from "react"
import { apiEndpoint } from "helpers/url_helper";

import MetaTags from 'react-meta-tags';
import Select from "react-select";
import moment from "moment";
import {
    Col,
    Row,
    Card,
    CardBody,
    Button,
    Container,
    ButtonGroup,
    UncontrolledTooltip,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    ButtonDropdown,
    CardTitle,
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import ReactToPrint from "react-to-print";
const { SearchBar } = Search;
import ReactBSAlert from "react-bootstrap-sweetalert";
import { connect } from "react-redux";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import ModalInFunctionalComponent from '../ViolationLogs/ViewImageModal';
import { ReportType, SpeedType } from '../ViolationLogs/ViolationLogsComponents';
import paginationFactory from 'react-bootstrap-table2-paginator';

//Style
const btnstylesObj = {
    "margin-top": '2rem',
  };

 // This is  custom csv export component
const ExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
        <Button  size="sm" id="csv-tooltip"
        className="buttons-copy buttons-html5"
        color="dark" onClick={ handleClick }> 
        <span>Csv</span></Button>
    );
  };

const ViolationTables = (props) => {
    //Print function
    const componentRef = useRef();
    const [Campusitems, setCampusItems] = useState([]);
    const [SelectedCampusitem, setSelectedCampusItem] = useState([]);
    const [selectedCampusVal, setCampusSelected] = useState(1);

    const [FromDtTm, setFrmDttm] = useState(moment().format("YYYY-MM-DD 00:00"));
    const [ToDtTm, setToDttm] = useState(moment().format("YYYY-MM-DD HH:mm"));

    const [FromSpeed, setFrmSpeed] = useState(20);
    const [ToSpeed, setToSpeed] = useState(100);
    const [BoolANPR, setANPR] = useState(true);

    const columns = [
        
        {
            dataField: "LocationName",
            text: "Location ",
            sort: false,
            width:"40px"
          
        },
    
        {
            dataField: "IncidentTime",
            text: "Incident Time",
            sort: false
        },
        {
          dataField: "TypeOfViolation",
          text: "Event ",
          sort: true,
      
          
      },
        {
            dataField: "RegistrationNumber",
            text: "Reg Number",
            sort: false,
            
        },
        // {
        //     dataField: "LaneNumber",
        //     text: "Lane Number",
        //     sort: true
        // },
        {
            dataField: "VehicleSpeed",
            text: "Speed ",
            sort: false
        },
        // {
        //     dataField: "SpeedLimit",
        //     text: "Speed Limit",
        //     sort: false
        // },
        {
            dataField: "ImagePath",
            text: "View",
            csvExport: false,
            sort: false,
            formatter: (value, row) => (
                // <span>
                //   {value}
                //   {row.SpeedLimit}
                // </span>
                <ModalInFunctionalComponent ImgPath={value}/>
              ),
        }
    ]


    const changeCampusSelectHandler = (event) => {
        setSelectedCampusItem(event);
        setCampusSelected(event.value);
    };

    const changeLocSelectHandler = (event) => {
        setSelectedLocItem(event);
        setLocSelected(event.value);
    };

    const changeFrmSpeedHandler= (value, ctx) => {
        if(value>parseInt(ToSpeed)){
            return "Enter Valid From Speed Value!!";
          }
          return true;
    }

    const changeToSpeedHandler = (value, ctx) => {
        if(value<parseInt(FromSpeed)){
          return "Enter Valid To Speed Value!!";
        }
        return true;
      }
   
      const changeFrmDateHandler= (value, ctx) => {
      //  console.log(value);
        if(value>ToDtTm){
            return "From date cannot be greater than To date!!!";
          }
          return true;
    }

    const changeToDateHandler = (value, ctx) => {
        if(value<FromDtTm){
          return "To date cannot be lesser than From date!!!";
        }
        return true;
      }
    const [selectedReportTypeVal, setReportType] = useState(1);
    const [selectedSpeedTypeVal, setSpeedType] = useState(1);


    const breadcrumbItems = [
        // { title: "Lexa", link: "#" },
        // { title: "Tables", link: "#" },
        // { title: "Editable Table", link: "#" },
    ]
    const [violations, setViolations] = useState([]);
  //  const SearchViolations = () => {
         useEffect(() => {
//console.log(props.CampusID+"Violationcomponent")
        // UserValidated
        fetch(apiEndpoint+"/GetLatestViolationLogs",
            {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  "intCampusID": props.CampusID,
                  "strToken": sessionStorage.getItem("Clear_AuthUser")
                })
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if(result!=undefined)
                    {
                        //console.log(result)
                  if(result.Violations!=undefined && result.Violations!="[null]"){
                    //console.log(JSON.parse(result.Locations));
                    setViolations([]);
                    setViolations(JSON.parse(result.Violations));
                  }
                  else{
                    setViolations([]);
                  }               
                }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    //setError(error);
                }
            )
        //}, [selectedCampusVal])
    }, [props.CampusID]);
  //  SearchViolations();

    // this function will copy to clipboard an entire table,
  // so you can paste it inside an excel or csv file
  const copyToClipboardAsTable = el => {
    var body = document.body,
      range,
      sel;
    if (document.createRange && window.getSelection) {
      range = document.createRange();
      sel = window.getSelection();
      sel.removeAllRanges();
      try {
        range.selectNodeContents(el);
        sel.addRange(range);
      } catch (e) {
        range.selectNode(el);
        sel.addRange(range);
      }
      document.execCommand("copy");
    } else if (body.createTextRange) {
      range = body.createTextRange();
      range.moveToElementText(el);
      range.select();
      range.execCommand("Copy");
    }

    setAlert (
        <ReactBSAlert
          success
        //   style={bsAlertStyle}
        //   title="Good job!"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="info"
        >
          Copied to clipboard!
        </ReactBSAlert>
      )
}
    return (
        <React.Fragment>

            
            <Row className="mt-3">
                <Col>
                    <Card >
                        <CardBody>
                            
                            <div className="table-responsive mt-2" style={{xOverflow:"auto"}}>
                             
                            <ToolkitProvider
                                    keyField="CampusID"
                                    data={violations}
                                    columns={columns}>
                                    {
                                        props => (
                                            <div>                          
             
            <BootstrapTable id="react-bs-table" 
             ref={componentRef}
            { ...props.baseProps } 
            // bootstrap4={true}
            // pagination={paginationFactory({sizePerPage: 10})}
            xOverflow="auto"
            />                                               
            </div>
                                        )
                                    }
                                </ToolkitProvider>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
<Row>
</Row>
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(ViolationTables);